import type { ChatCardProps } from "../../types/ChatCard";
import { AccessGroupListingCard } from "./copilot/AccessGroupListingCard";
import { CommunitySegmentListingCard } from "./copilot/CommunitySegmentListingCard";
import { ConfirmationCard } from "./copilot/ConfirmationCard";
import { InvitationCard } from "./copilot/InvitationCard";
import { InvitationLinkListingCard } from "./copilot/InvitationLinkListingCard";
import { LinkCard } from "./copilot/LinkCard";
import { MemberListingCard } from "./copilot/MemberListingCard";
import { MemberTagListingCard } from "./copilot/MemberTagListingCard";
import { ProfileFieldCard } from "./copilot/ProfileFieldCard";
import { ProfileFieldListingCard } from "./copilot/ProfileFieldListingCard";
import { SpaceGroupListingCard } from "./copilot/SpaceGroupListingCard";
import { SpaceListingCard } from "./copilot/SpaceListingCard";

const CARD_COMPONENTS = {
  invitation_link_card: InvitationCard,
  member_listing_card: MemberListingCard,
  confirmation_card: ConfirmationCard,
  link_card: LinkCard,
  invitation_link_listing_card: InvitationLinkListingCard,
  member_tag_listing_card: MemberTagListingCard,
  profile_field_card: ProfileFieldCard,
  profile_field_listing_card: ProfileFieldListingCard,
  space_group_listing_card: SpaceGroupListingCard,
  space_listing_card: SpaceListingCard,
  access_group_listing_card: AccessGroupListingCard,
  community_segment_listing_card: CommunitySegmentListingCard,
} as const;

export const ChatCard = ({ type, content }: ChatCardProps) => {
  const Component = CARD_COMPONENTS[type] as React.ComponentType<
    typeof content
  >;

  if (!Component) {
    return null;
  }

  return <Component {...content} />;
};
